import React, { useEffect, useState } from 'react'
import api from '../../api';
import { ProgressBar } from 'primereact/progressbar';
import { ProgressSpinner } from 'primereact/progressspinner';
import { MapPin, Building, Home, Filter } from 'lucide-react';

function Section_1() {
  const userID = sessionStorage.getItem("RoleCode");
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false);
  const [taluk, setTaluk] = useState("");
  const [village, setVillage] = useState("");
  const [villages, setVillages] = useState([]);
  const [filteredData, setFilteredData] = useState(null);

  const district = "Chitradurga District";
  const districtData = {
    "Chitradurga District": {
      "Chitradurga": [
        "Jodichikkenahalli",
        "Kyadigere",
        "Hale Dyamavvana Halli",
        "J J Hatti",
        "Kasavanahalli",
        "Ennegere",
        "Gonur",
        "Venkateshwara Badavane",
        "Gandhi Nagara",
        "Kasavarahatti"
      ],
      "Hiriyur": [
        "Hosakere",
        "Halagaladdi",
        "Khandenahalli Palya",
        "Benakanahalli",
        "P D Kote",
        "Adivala Farm",
        "T G Colony",
        "Bovi Colony",
        "Adivala",
        "Gollarahatti"
      ],
      "Holalkere": [
        "Kolalu",
        "Echaghatta",
        "T-Nulenuru",
        "Kereyagalahalli",
        "Halenahalli",
        "Hulikere",
        "Kudineer Katte",
        "Talya",
        "Tekalarvatti",
        "Holalkere_Gollarahatti"
      ]
    }
  };

  useEffect(() => {
    if (taluk) {
      setVillages(districtData[district][taluk] || []);
      setVillage("");
    } else {
      setVillages([]);
      setVillage("");
    }
  }, [taluk]);

  useEffect(() => {
    if (!data) return;

    const filterDataByLocation = (items, taluk, village) => {
      if (!Array.isArray(items)) return items;

      return items.filter(item => {
        const itemTaluk = item.taluk_name || item.fld_taluk_name;
        const itemVillage = item.village_name || item.fld_village_name;

        const talukMatch = !taluk || itemTaluk === taluk;
        const villageMatch = !village || itemVillage === village;

        return talukMatch && villageMatch;
      });
    };

    const filtered = JSON.parse(JSON.stringify(data));

    const filterNestedData = (obj) => {
      if (Array.isArray(obj)) {
        return filterDataByLocation(obj, taluk, village);
      } else if (obj && typeof obj === 'object') {
        const result = {};
        for (const key in obj) {
          result[key] = filterNestedData(obj[key]);
        }
        return result;
      }
      return obj;
    };

    setFilteredData(filterNestedData(filtered));
  }, [data, taluk, village]);

  const rawData = async () => {
    try {
      setLoading(true)
      const url = 'section_1_dashboard'
      const requestData = {
        login_user_id: userID,
        synceddatetime: "2023-01-24 11:57:34",
        FormCode: "314",
        ApiKey: "kavin",
        AppTypeNo: "3",
        AppVersion: "1.0.0"
      };
      const result = await api.get_Dashboard_Section(url, requestData);
      console.log("result ...", result)
      setData(result.responsemessage.household_dashboard_1)
    } catch (error) {
      console.error("Error fetching requested data:", error);
    } finally {
      setLoading(false)
    }
  };

  useEffect(() => {
    rawData();
  }, []);

  const DashboardCards = () => {
    if (!filteredData) return null;

    const extractDataFields = (items, subCategory) => {
      if (!items || items.length === 0) return null;

      const firstItem = items[0];

      const fieldMappings = {
        "Family_Type_Stats": {
          countField: "family_type_count",
          nameField: "type_of_family"
        },
        "Total_Family_Member": {
          countField: "total_family_members",
          nameField: "village_name"
        },
        "Religion": {
          countField: "religion_count",
          nameField: "religion_name"
        },
        "Other_Religion": {
          countField: "other_religion_count",
          nameField: "other_religion"
        },
        "Caste_Category": {
          countField: "caste_count",
          nameField: "caste_name"
        },
        "Card_Holder_Status_Stats": {
          countField: "count",
          nameField: "card_status"
        },
        "Total_Family_Income": {
          countField: "avg_family_income",
          nameField: "fld_village_name",
          isIncome: true
        },
        "Property_They_Own": {
          countField: "property_own_count",
          nameField: "property_own_Name"
        },
        "Property_Details": {
          countField: "property_type_count",
          nameField: "property_type"
        },
        "People_With_Very_Secure_Job_Security": {
          countField: "count_people_secure_job",
          nameField: "fld_village_name"
        },
        "People_With_Somewhat_Secure_Job_Security": {
          countField: "count_people_somewhat_secure_job",
          nameField: "fld_village_name"
        },
        "People_With_Neutral_Job_Security": {
          countField: "count_people_neutral_secure_job",
          nameField: "fld_village_name"
        },
        "People_With_Somewhat_Insecure_Job_Security": {
          countField: "count_people_somewhat_insecure_job",
          nameField: "fld_village_name"
        },
        "People_With_Very_Insecure_Job_Security": {
          countField: "count_people_very_insecure_job",
          nameField: "fld_village_name"
        },
        "People_With_Savings": {
          countField: "count_people_with_savings",
          nameField: "fld_village_name"
        },
        "People_Without_Savings": {
          countField: "count_people_without_savings",
          nameField: "fld_village_name"
        },
        "People_With_Debt": {
          countField: "count_people_with_debt",
          nameField: "fld_village_name"
        },
        "People_Without_Debt": {
          countField: "count_people_without_debt",
          nameField: "fld_village_name"
        },
        "Having_Insurance": {
          countField: "count_insurance_yes",
          nameField: "fld_village_name"
        },
        "Not_Having_Insurance": {
          countField: "count_insurance_no",
          nameField: "fld_village_name"
        },
        "Government_Insurance": {
          countField: "count_insurance_government",
          nameField: "fld_village_name"
        },
        "Private_Insurance": {
          countField: "count_insurance_private",
          nameField: "fld_village_name"
        },
        "Both_Insurance": {
          countField: "count_insurance_yes_combined",
          nameField: "fld_village_name"
        },
        "Recent_Vital_Event_In_Family": {
          countField: "event_family_count",
          nameField: "event_family_name"
        },
        "Weight_For_Age": {
          countField: "count",
          nameField: "fld_weight_for_age_who_name"
        },
        "Height_For_Age": {
          countField: "count",
          nameField: "fld_height_for_age_who_name"
        },
        "Education_Level_Illiterate": {
          countField: "count_education_illiterate",
          nameField: "fld_village_name"
        },
        "Education_Level_Primary_1_5": {
          countField: "count_education_primary_1_5",
          nameField: "fld_village_name"
        },
        "Education_Level_Middle_6_8": {
          countField: "count_education_middle_6_8",
          nameField: "fld_village_name"
        },
        "Education_Level_High_School_9_10": {
          countField: "count_education_high_school_9_10",
          nameField: "fld_village_name"
        },
        "Education_Level_Higher_Secondary_11_12": {
          countField: "count_education_level_higher_secondary_11_12",
          nameField: "fld_village_name"
        },
        "Education_Level_Diploma": {
          countField: "count_education_level_diploma",
          nameField: "fld_village_name"
        },
        "Education_Level_Graduate_And_Above": {
          countField: "count_education_level_graduate_and_above",
          nameField: "fld_village_name"
        },
        "Education_Level_Play_Home": {
          countField: "count_education_under_5_play_home",
          nameField: "fld_village_name"
        },
        "Education_Level_Anganwadi": {
          countField: "count_education_under_5_anganwadi",
          nameField: "fld_village_name"
        },
        "Education_Level_UKG": {
          countField: "count_eduction_under_5_ukg",
          nameField: "fld_village_name"
        },
        "Education_Level_LKG": {
          countField: "count_education_under_5_lkg",
          nameField: "fld_village_name"
        }
      };

      const mapping = fieldMappings[subCategory];

      if (mapping) {
        return {
          countField: mapping.countField,
          nameField: mapping.nameField,
          isIncome: mapping.isIncome || false
        };
      }

      const countField = Object.keys(firstItem).find(key =>
        key.toLowerCase().includes('count') ||
        key.toLowerCase().includes('_count') ||
        key.toLowerCase().includes('income')
      );

      const nameField = Object.keys(firstItem).find(key =>
        (key.toLowerCase().includes('name') && !key.includes('taluk') && !key.includes('village')) ||
        key.toLowerCase().includes('type') ||
        key.toLowerCase().includes('status') ||
        key.toLowerCase().includes('religion') ||
        key.toLowerCase().includes('caste') ||
        key.toLowerCase().includes('property') ||
        key.toLowerCase().includes('event')
      );

      return { countField, nameField, isIncome: false };
    };

    const aggregateDataByCategory = (items, nameField, countField, isIncome = false) => {
      if (!items || !nameField || !countField) return [];

      const aggregated = {};

      items.forEach(item => {
        const categoryName = item[nameField];
        let countValue = parseFloat(item[countField]) || 0;

        if (categoryName && categoryName !== "") {
          if (!aggregated[categoryName]) {
            aggregated[categoryName] = {
              name: categoryName,
              count: 0,
              isIncome: isIncome
            };
          }
          aggregated[categoryName].count += countValue;
        }
      });

      const result = Object.values(aggregated);

      if (!isIncome) {
        const totalCount = result.reduce((sum, item) => sum + item.count, 0);
        result.forEach(item => {
          item.percentage = totalCount > 0 ? (item.count / totalCount) * 100 : 0;
        });
      }

      return result;
    };

    const cardColors = {
      "Social Characteristics": "#ea580c",
      "Economic Condition": "#16a34a",
      "Demographic Details": "#c2185b"
    };

    const subCategoryLabels = {
      "Family_Type_Stats": "Family Type Statistics",
      "Total_Family_Member": "Total Family Members",
      "Religion": "Religion Distribution",
      "Other_Religion": "Other Religion Details",
      "Caste_Category": "Caste Category Distribution",
      "Card_Holder_Status_Stats": "Card Holder Status",
      "Total_Family_Income": "Average Family Income",
      "Property_They_Own": "Property Ownership",
      "Property_Details": "Property Type Details",
      "People_With_Very_Secure_Job_Security": "Very Secure Job Security",
      "People_With_Somewhat_Secure_Job_Security": "Somewhat Secure Job Security",
      "People_With_Neutral_Job_Security": "Neutral Job Security",
      "People_With_Somewhat_Insecure_Job_Security": "Somewhat Insecure Job Security",
      "People_With_Very_Insecure_Job_Security": "Very Insecure Job Security",
      "People_With_Savings": "People With Savings",
      "People_Without_Savings": "People Without Savings",
      "People_With_Debt": "People With Debt",
      "People_Without_Debt": "People Without Debt",
      "Having_Insurance": "Having Insurance",
      "Not_Having_Insurance": "Not Having Insurance",
      "Government_Insurance": "Government Insurance",
      "Private_Insurance": "Private Insurance",
      "Both_Insurance": "Both Insurance Types",
      "Recent_Vital_Event_In_Family": "Recent Vital Events",
      "Weight_For_Age": "Weight for Age Status",
      "Height_For_Age": "Height for Age Status",
      "Education_Level_Illiterate": "Illiterate",
      "Education_Level_Primary_1_5": "Primary Education (1-5)",
      "Education_Level_Middle_6_8": "Middle School (6-8)",
      "Education_Level_High_School_9_10": "High School (9-10)",
      "Education_Level_Higher_Secondary_11_12": "Higher Secondary (11-12)",
      "Education_Level_Diploma": "Diploma",
      "Education_Level_Graduate_And_Above": "Graduate and Above",
      "Education_Level_Play_Home": "Play Home (Under 5)",
      "Education_Level_Anganwadi": "Anganwadi (Under 5)",
      "Education_Level_UKG": "UKG (Under 5)",
      "Education_Level_LKG": "LKG (Under 5)"
    };

    const renderCardBlock = (category, subCategory, items, label) => {
      if (!Array.isArray(items) || items.length === 0) return null;

      const { countField, nameField, isIncome } = extractDataFields(items, subCategory);

      if (!countField || !nameField) {
        return (
          <div className="bar text-600" key={`${category}-${subCategory}`}>
            <div>
              <div className="flex justify-content-between align-items-center">
                <p className="w-9 font-semibold">{label}</p>
                <p className="font-medium">No data available</p>
              </div>
            </div>
          </div>
        );
      }

      const aggregatedItems = aggregateDataByCategory(items, nameField, countField, isIncome);

      if (aggregatedItems.length === 0) return null;

      const totalCount = aggregatedItems.reduce((sum, item) => sum + item.count, 0);
      const cardColor = cardColors[category] || "#4ca8db";

      return (
        <div className="bar text-600" key={`${category}-${subCategory}`}>
          <div>
            <div className="flex justify-content-between align-items-center">
              <p className="w-9 font-semibold">{label}</p>
              <p className="font-medium">
                {isIncome ? 'Average Income' : `Total - ${totalCount}`}
              </p>
            </div>

            <div className="grid flex align-items-center mb-3 headingCard f12 font-semibold">
              <div className="col-5">Category</div>
              <div className="col-2 text-center">{isIncome ? 'Income (₹)' : 'Count'}</div>
              <div className="col-5">{isIncome ? '' : 'Percentage'}</div>
            </div>

            {aggregatedItems.map((item, idx) => (
              <div className="grid flex align-items-center mt-2 f12" key={idx}>
                <div className="col-5">
                  <span className="font-medium">{item.name || 'Unknown'}</span>
                </div>
                <div className="col-2 text-center">
                  <span>
                    {isIncome ? `₹${item.count.toLocaleString('en-IN')}` : item.count}
                  </span>
                </div>
                <div className="col-5">
                  {!isIncome && (
                    <div className="flex align-items-center gap-2">
                      <div style={{
                        height: "8px",
                        backgroundColor: "#e0e0e0",
                        borderRadius: "10px",
                        overflow: "hidden",
                        position: "relative",
                        flex: 1
                      }}>
                        <div style={{
                          height: "100%",
                          backgroundColor: cardColor,
                          width: `${parseFloat(item.percentage) || 0}%`,
                          borderRadius: "10px",
                          transition: "width 0.3s ease"
                        }} />
                      </div>
                      <span style={{ minWidth: '45px', fontSize: '11px' }}>
                        {parseFloat(item.percentage || 0).toFixed(1)}%
                      </span>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      );
    };

    const renderMainCategories = () => {
      if (!filteredData || !filteredData["Socio Economic And Demographic Determinants"]) return null;

      const mainData = filteredData["Socio Economic And Demographic Determinants"];

      const targetCategories = [
        "Social Characteristics",
        "Economic Condition",
        "Demographic Details"
      ];

      return targetCategories.map(mainCategory => {
        const mainCategoryData = mainData[mainCategory];
        if (!mainCategoryData || typeof mainCategoryData !== 'object') return null;

        return (
          <div key={mainCategory} className="mb-6">
            <div className="font-bold text-xl mb-4 text-gray-800 border-b-2 pb-2"
              style={{ borderColor: cardColors[mainCategory] }}>
              {mainCategory}
            </div>

            <div className="first-cards">
              <div className="first-sub">
                {Object.keys(mainCategoryData).map(subCategory => {
                  const items = mainCategoryData[subCategory];
                  if (!Array.isArray(items) || items.length === 0) return null;

                  const label = subCategoryLabels[subCategory] ||
                    subCategory.replace(/_/g, ' ')
                      .replace(/([A-Z])/g, ' $1')
                      .replace(/\b\w/g, l => l.toUpperCase())
                      .trim();

                  return (
                    <div key={`${mainCategory}-${subCategory}`}>
                      {renderCardBlock(mainCategory, subCategory, items, label)}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        );
      });
    };

    return (
      <div className='render-container'>
        {renderMainCategories()}
      </div>
    );
  };

  const activeFiltersCount = [taluk, village].filter(Boolean).length;

  return (
    <div style={{ backgroundColor: '#eff6ff', minHeight: '100vh' }}>
      {loading && (
        <div className="backdrop">
          <ProgressSpinner className='progressBar' />
        </div>
      )}

      <div style={{
        background: 'linear-gradient(to bottom right, #ffffff, #f9fafb)',
        borderRadius: '0.75rem',
        boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
        border: '1px solid #e5e7eb',
        overflow: 'hidden',
        marginBottom: '1rem'
      }}>
        {/* <div style={{
          background: 'linear-gradient(to right, #3b82f6, #2563eb)',
          padding: '1rem 1.5rem'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
              <div style={{
                backgroundColor: 'rgba(255, 255, 255, 0.2)',
                backdropFilter: 'blur(8px)',
                borderRadius: '0.5rem',
                padding: '0.5rem'
              }}>
                <Filter style={{ width: '1.25rem', height: '1.25rem', color: 'white' }} />
              </div>
              <div>
                <h2 style={{ color: 'white', fontWeight: 600, fontSize: '1.125rem', margin: 0 }}>Location Filters</h2>
                <p style={{ color: '#dbeafe', fontSize: '0.75rem', margin: 0 }}>Select your location hierarchy</p>
              </div>
            </div>
            {activeFiltersCount > 0 && (
              <div style={{
                backgroundColor: 'rgba(255, 255, 255, 0.2)',
                backdropFilter: 'blur(8px)',
                padding: '0.375rem 0.75rem',
                borderRadius: '9999px'
              }}>
                <span style={{ color: 'white', fontSize: '0.875rem', fontWeight: 500 }}>
                  {activeFiltersCount} {activeFiltersCount === 1 ? 'filter' : 'filters'} active
                </span>
              </div>
            )}
          </div>
        </div> */}

        <div style={{ padding: '1.5rem' }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '1.5rem'
          }}>
            <div>
              <label style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                color: '#374151',
                marginBottom: '0.625rem',
                fontWeight: 500
              }}>
                <div style={{
                  backgroundColor: '#dbeafe',
                  padding: '0.375rem',
                  borderRadius: '0.5rem'
                }}>
                  <MapPin style={{ width: '1rem', height: '1rem', color: '#2563eb' }} />
                </div>
                <span style={{ fontSize: '0.875rem' }}>District</span>
              </label>
              <div style={{ position: 'relative' }}>
                <input
                  type="text"
                  value={district}
                  disabled
                  style={{
                    width: '100%',
                    padding: '0.75rem 1rem',
                    border: '2px solid #e5e7eb',
                    borderRadius: '0.5rem',
                    backgroundColor: '#f9fafb',
                    fontSize: '0.875rem',
                    fontWeight: 500,
                    color: '#4b5563',
                    cursor: 'not-allowed'
                  }}
                />
                <div style={{
                  position: 'absolute',
                  right: '0.75rem',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  backgroundColor: '#e5e7eb',
                  padding: '0.125rem 0.5rem',
                  borderRadius: '0.25rem',
                  fontSize: '0.75rem',
                  color: '#6b7280'
                }}>
                  Fixed
                </div>
              </div>
            </div>

            <div>
              <label style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                color: '#374151',
                marginBottom: '0.625rem',
                fontWeight: 500
              }}>
                <div style={{
                  backgroundColor: '#dcfce7',
                  padding: '0.375rem',
                  borderRadius: '0.5rem'
                }}>
                  <Building style={{ width: '1rem', height: '1rem', color: '#16a34a' }} />
                </div>
                <span style={{ fontSize: '0.875rem' }}>Taluk</span>
              </label>
              <div style={{ position: 'relative' }}>
                <select
                  style={{
                    width: '100%',
                    padding: '0.75rem 2.5rem 0.75rem 1rem',
                    border: '2px solid #e5e7eb',
                    borderRadius: '0.5rem',
                    fontSize: '0.875rem',
                    fontWeight: 500,
                    appearance: 'none',
                    cursor: 'pointer',
                    backgroundColor: 'white'
                  }}
                  value={taluk}
                  onChange={(e) => setTaluk(e.target.value)}
                >
                  <option value="">All Taluks</option>
                  {Object.keys(districtData[district] || {}).map((t) => (
                    <option key={t} value={t}>{t}</option>
                  ))}
                </select>
                <div style={{
                  position: 'absolute',
                  right: '0.75rem',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  pointerEvents: 'none'
                }}>
                  <svg style={{ width: '1.25rem', height: '1.25rem', color: '#9ca3af' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </div>
              </div>
            </div>

            <div>
              <label style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                color: '#374151',
                marginBottom: '0.625rem',
                fontWeight: 500
              }}>
                <div style={{
                  backgroundColor: '#f3e8ff',
                  padding: '0.375rem',
                  borderRadius: '0.5rem'
                }}>
                  <Home style={{ width: '1rem', height: '1rem', color: '#9333ea' }} />
                </div>
                <span style={{ fontSize: '0.875rem' }}>Village</span>
              </label>
              <div style={{ position: 'relative' }}>
                <select
                  style={{
                    width: '100%',
                    padding: '0.75rem 2.5rem 0.75rem 1rem',
                    border: '2px solid #e5e7eb',
                    borderRadius: '0.5rem',
                    fontSize: '0.875rem',
                    fontWeight: 500,
                    appearance: 'none',
                    cursor: !villages.length ? 'not-allowed' : 'pointer',
                    backgroundColor: !villages.length ? '#f9fafb' : 'white',
                    color: !villages.length ? '#9ca3af' : 'inherit'
                  }}
                  value={village}
                  onChange={(e) => setVillage(e.target.value)}
                  disabled={!villages.length}
                >
                  <option value="">All Villages</option>
                  {villages.map((v) => (
                    <option key={v} value={v}>{v}</option>
                  ))}
                </select>
                <div style={{
                  position: 'absolute',
                  right: '0.75rem',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  pointerEvents: 'none'
                }}>
                  <svg style={{ width: '1.25rem', height: '1.25rem', color: '#9ca3af' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </div>
              </div>
            </div>
          </div>

          <div style={{
            marginTop: '1.5rem',
            paddingTop: '1.25rem',
            borderTop: '1px solid #e5e7eb'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '1rem' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <div style={{
                  width: '0.5rem',
                  height: '0.5rem',
                  backgroundColor: '#22c55e',
                  borderRadius: '9999px',
                  animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite'
                }}></div>
                <span style={{ fontSize: '0.875rem', color: '#4b5563', fontWeight: 500 }}>Active Selection:</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', fontSize: '0.875rem', flexWrap: 'wrap' }}>
                {taluk ? (
                  <span style={{
                    backgroundColor: '#dcfce7',
                    color: '#15803d',
                    padding: '0.375rem 0.75rem',
                    borderRadius: '0.5rem',
                    fontWeight: 500
                  }}>
                    📍 {taluk}
                  </span>
                ) : (
                  <span style={{ color: '#9ca3af' }}>No taluk selected</span>
                )}
                {village ? (
                  <span style={{
                    backgroundColor: '#f3e8ff',
                    color: '#7e22ce',
                    padding: '0.375rem 0.75rem',
                    borderRadius: '0.5rem',
                    fontWeight: 500
                  }}>
                    🏘️ {village}
                  </span>
                ) : taluk ? (
                  <span style={{ color: '#9ca3af' }}>No village selected</span>
                ) : null}
                {!taluk && !village && (
                  <span style={{
                    color: '#6b7280',
                    backgroundColor: '#f3f4f6',
                    padding: '0.375rem 0.75rem',
                    borderRadius: '0.5rem'
                  }}>
                    Showing all data for {district}
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="gridDashboard pt-3">
        {filteredData && <DashboardCards />}
      </div>

      <style>{`
        @keyframes pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }
      `}</style>
    </div>
  )
}

export default Section_1